import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function LocationPermission({
  show,
  handleRetry,
  handleDefaultLocation,
}) {
  return (
    <React.Fragment>
      <Dialog
        open={show}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <h4>{"Location Permission Required"}</h4>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              We need your location permission to provide better service. Please
              allow location access.
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDefaultLocation}> Use Default Location</Button>
          <Button onClick={handleRetry}>Retry</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
